import React from 'react'
import { Grid } from '@mui/material'
import { useNavigate } from 'react-router-dom'
import VisibilityIcon from '@mui/icons-material/Visibility'
import { useGetOrganizationQuery } from 'services/organizations'
import getButtonCell from 'components/generic/datagrid/cells/ButtonCell'
import BasicDataGrid from 'components/generic/datagrid'
import { transformStrToUnderscore } from 'utils/router'

const getOrganizationsColumnConfig = navigate => [
  {
    field: 'name',
    headerName: 'Organization Name',
    flex: 1,
  },
  {
    field: 'yardNames',
    headerName: 'Yard Names',
    flex: 1,
  },
  {
    field: 'yardIds',
    headerName: 'Yard Ids',
    flex: 1,
  },
  {
    field: 'view',
    headerName: 'Actions',
    type: 'actions',
    width: 150,
    renderCell: params =>
      getButtonCell(params, 'View', <VisibilityIcon />, () =>
        navigate(transformStrToUnderscore(params.row?.name), {
          state: { id: params.row?.id },
        }),
      ),
  },
]

const Organizations = () => {
  const { data, isLoading } = useGetOrganizationQuery()
  const navigate = useNavigate()
  const columns = getOrganizationsColumnConfig(navigate)

  return (
    <Grid p={3} sx={{ height: '100%' }} item container flexDirection="column">
      <BasicDataGrid hideFooter rows={[data]} columns={columns} loading={isLoading} />
    </Grid>
  )
}

export default Organizations
